import {GoogleMapsAPIWrapper} from '@agm/core';
import {Directive, EventEmitter, Input, Output, SimpleChange, SimpleChanges} from '@angular/core';
import {google} from "google-maps";
import {GoogleMap} from "@agm/core/services/google-maps-types";
import DirectionsRequest = google.maps.DirectionsRequest;
import DirectionsWaypoint = google.maps.DirectionsWaypoint;
import DirectionsResult = google.maps.DirectionsResult;
import {DiscoverTypeEnum} from "../enums/discoverType.enum";
import {PointModel} from "../models/point.model";
import * as moment from "moment";

@Directive({
  selector: 'agm-directions'
})
export class DirectionsMapDirective {
  @Input() origin:any;
  @Input() destination:any;
  @Input() draggable: boolean = true;

  @Input() waypoints: PointModel[];
  @Output() waypointsChange: EventEmitter<PointModel[]> = new EventEmitter();

  @Output() directionDetails: EventEmitter<any> = new EventEmitter();
  @Output() directions: EventEmitter<any> = new EventEmitter();

  public estimatedTime: any;
  public estimatedDistance: any;

  public polylineOptions = {
    strokeWeight: 8,
    strokeOpacity: 0.7,
    strokeColor:  '#00468c'
  };

  private map: GoogleMap;
  private directionsService;
  private directionsDisplay;

  private listeners = [];

  constructor (private gmapsApi: GoogleMapsAPIWrapper) {
  }

  ngOnInit(){
    this.directionsService = new google.maps.DirectionsService;
    this.directionsDisplay = new google.maps.DirectionsRenderer;
    this.gmapsApi.getNativeMap().then((map: GoogleMap) => {
      this.map = map;
      this.directionsDisplay.setMap(map);
    });
    this.listeners.push(google.maps.event.addListener(this.directionsDisplay, 'directions_changed', this.directionsChangedCb.bind(this)));
    this.clearDirections();
  }

  ngOnDestroy(){
    this.listeners.forEach(listener => {
      google.maps.event.removeListener(listener);
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.destination){
      changes.destination.currentValue ? this.updateDirections() : changes.destination.previousValue ? this.clearDirections() : '';
    }
  }

  public directionsChangedCb(){
    this.directions.emit(this.directionsDisplay.directions);
    if(this.directionsDisplay.directions.routes.length && this.directionsDisplay.directions.routes[0].legs.length){
      this.waypointsChange.emit(this.directionsDisplay.directions.routes[0].legs[0].via_waypoints);
    }
  }

  public clearDirections(){
    // this.directionsDisplay.setDirections({geocoded_waypoints: [], routes: []});
    this.directionsDisplay.setOptions({
      directions: {
        geocoded_waypoints: [],
        routes: [],
        request: {
          travelMode: google.maps.TravelMode.DRIVING
        }
      },
      draggable: false,
    });
    // this.directionDetails.emit();
  }

  public updateDirections(){
    let latLngA = new google.maps.LatLng(this.origin.lat, this.origin.lng);
    let latLngB = new google.maps.LatLng(this.destination.lat, this.destination.lng);

    this.clearDirections();
    let options: DirectionsRequest = {
      origin: latLngA,
      destination: latLngB,
      avoidTolls: true,
      travelMode: google.maps.TravelMode.DRIVING,
      provideRouteAlternatives: true
    };
    if (this.waypoints){
      let waypoints: DirectionsWaypoint[];
      waypoints = this.waypoints.map(waypoint => {
        return {
          location: new google.maps.LatLng(waypoint.lat, waypoint.lng),
          stopover: true,
        }
      });
      options.waypoints = waypoints;
    }
    this.directionsService.route(options, (response: any, status: any) => {
      if (status === 'OK') {
        console.log(latLngA.toJSON(), latLngB.toJSON());
        console.log('Directions response', response);

        this.estimatedTime = response.routes[0].legs.reduce((s, l) => s + l.duration.value, 0);
        this.estimatedDistance = response.routes[0].legs.reduce((s, l) => s + l.distance.value, 0);
        let directionSummary = {
          "duration": {
            "text": moment.duration(this.estimatedTime, "seconds").format("HH [h] mm [m]"),
            "value": this.estimatedTime
          },
          "distance": {
            "text": this.estimatedDistance > 1000 ? (this.estimatedDistance/1000).toFixed(2) + ' km' : this.estimatedDistance + ' m',
            "value": this.estimatedDistance
          }
        };
        response.summary = directionSummary;
        this.directionDetails.emit(response);
        this.directionsDisplay.setOptions({
          directions: response,
          draggable: this.draggable,
          polylineOptions: this.polylineOptions
        });
        this.map.setZoom(30);
        console.log( 'Estimated travel time: ' + response.summary.duration.text + ' (' + response.summary.distance.text + ')' );
      } else {
        console.log('Directions request failed due to ' + status);
      }
    });
  }
  //
  // private getcomputeDistance(latLngA: any , latLngB: any )
  // {
  //   return (google.maps.geometry.spherical.computeDistanceBetween(latLngA, latLngB) / 1000).toFixed(2);
  // }
}



// WEBPACK FOOTER //
// C:/Development/Private Projects/random-ride/RandomRide/src/app/map/map-directions.directive.ts